var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveGuestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b,.c{fill:#6b6b95;}.b{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,1.8a36.082,36.082,0,0,0-4.677.317A2.53,2.53,0,0,0,2.117,4.323,36.083,36.083,0,0,0,1.8,9a36.083,36.083,0,0,0,.317,4.677,2.53,2.53,0,0,0,2.207,2.207A36.076,36.076,0,0,0,9,16.2a36.077,36.077,0,0,0,4.677-.317,2.53,2.53,0,0,0,2.207-2.207A36.077,36.077,0,0,0,16.2,9a36.076,36.076,0,0,0-.317-4.677,2.53,2.53,0,0,0-2.207-2.207A36.084,36.084,0,0,0,9,1.8ZM4.088.332A4.33,4.33,0,0,0,.332,4.088,37.88,37.88,0,0,0,0,9a37.882,37.882,0,0,0,.332,4.912,4.33,4.33,0,0,0,3.756,3.756A37.873,37.873,0,0,0,9,18a37.875,37.875,0,0,0,4.912-.332,4.329,4.329,0,0,0,3.756-3.756A37.875,37.875,0,0,0,18,9a37.873,37.873,0,0,0-.332-4.912A4.33,4.33,0,0,0,13.912.332,37.882,37.882,0,0,0,9,0,37.88,37.88,0,0,0,4.088.332Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.264.264a.9.9,0,0,1,1.273,0L3.6,2.327,5.664.264A.9.9,0,0,1,6.936,1.536L4.873,3.6,6.936,5.664A.9.9,0,0,1,5.664,6.936L3.6,4.873,1.536,6.936A.9.9,0,0,1,.264,5.664L2.327,3.6.264,1.536A.9.9,0,0,1,.264.264Z",
    transform: "translate(5.4 5.4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveGuestIcon);
export default __webpack_public_path__ + "static/media/remove-guest-icon.0e07bd99bc5982b84eceda273d842909.svg";
export { ForwardRef as ReactComponent };